import React from "react";
import styled from "styled-components";

interface ContentProps {
  height?: string;
  children: JSX.Element | JSX.Element[];
  style?: React.CSSProperties;
  mainSectionStyle?: React.CSSProperties;
}
interface WrapperProps {
  height?: string;
}

const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  height: ${({ height }) => height || "90vh"};
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.colors.neutrals_400};
`;
const MainSection = styled.div`
  width: 85%;
  min-height: 95vh;
  @media (max-width: 1280px) {
    width: 92%;
  }
  @media (max-width: 1024px) {
    width: 96%;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const ContentWrapper: React.FC<ContentProps> = ({
  children,
  height,
  style,
  mainSectionStyle,
}) => {
  return (
    <Wrapper height={height} style={style}>
      <MainSection style={mainSectionStyle}>{children}</MainSection>
    </Wrapper>
  );
};
